import PieChartWidget from './pie-chart.widget';
export default PieChartWidget;
